import CcyConfig from '../json/CurrencyConfig.json';
import { Currency } from '../models/Currency';


export const SUPPORT_CCY_LIST = [
	'SGD',
	'USD',
	'EUR',
	'GBP',
	'AUD',
    'JPY',
    'SEK',
    'NOK',
	'DKK',
	'CAD',
	'CHF',
	'HKD',
	'CNH',
    'NZD',
	'VND',
	'PHP',
	'TWD',
	'MYR',
	'KRW',
	'THB',
	'IDR',
	'INR',
];

export type CcyExtraInfo = {
	[key: string] : any;
	// cca3: string,
	// decimalDigits: number,
	// decimalSeparator: string,
	// name: string,
	// rateDigits: number,
	// spaceBetweenAmountAndSymbol: boolean,
	// symbol: string,
	// symbolOnLeft: boolean,
	// thousandsSeparator: string,
};
export const blankCcyData = {
	cca3: '',
	decimalDigits: 2,
	decimalSeparator: '.',
	name: {
		en_name: "",
		ja_name: ""
	},
	rateDigits: 4,
	spaceBetweenAmountAndSymbol: false,
	symbol: '',
	symbolOnLeft: true,
	thousandsSeparator: ',',
};

export const getCcyDataByCcy = (ccy: string): Currency => {
	if (ccy !== "") {
		const data: CcyExtraInfo = CcyConfig;
		return data[ccy];
	}else{
		return blankCcyData;
	}
};

